// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1UsbA","loading":"style_loading__3HEeg"};